import { ShowChartOutlined } from '@mui/icons-material';
import {
  CardContainer,
  DataTable,
  type DataTableColumn,
  type DataTableRow,
} from 'finara-components';

interface ClientActivityTableProps {
  columns: DataTableColumn[];
  data: DataTableRow[];
  title?: string;
}

export const ClientActivityTable: React.FC<ClientActivityTableProps> = ({
  columns,
  data,
  title = 'Resumen de Actividad por Cliente',
}) => {
  return (
    <CardContainer
      title={title}
      icon={<ShowChartOutlined className="mr-2 text-muted" fontSize="small" />}
    >
      <div className="overflow-scroll">
        <DataTable columns={columns} data={data} />
      </div>
    </CardContainer>
  );
};
